module.exports = __webpack_public_path__ + "img/64_13.6dcea6d8.png";